var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFiles(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 18,
    viewBox: "0 0 16 18",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-2 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h20v20h-20z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14.1666667 14.1666667v1.6666666c.0001238.4419066-.1753054.8657628-.4876946 1.1783239-.3123892.3125612-.7361488.4883428-1.1780554.4883428h-7.5009167c-.44190661 0-.8657628-.1753054-1.17832391-.4876946-.31256112-.3123892-.48822343-.7361488-.48834282-1.1780554v-9.16758333c-.00012372-.44190661.17530543-.8657628.48769463-1.17832392.31238921-.31256111.73614882-.48834275 1.17805543-.48834275h1.66758334"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.6666667 6.25h-2.5c-.690356 0-1.25-.55964406-1.25-1.25v-2.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.66666667 12.5v-8.33333333c0-.92047459.74619208-1.66666667 1.66666666-1.66666667h5.05038337c.4420297 0 .8659552.1755953 1.1785166.48815833l1.616275 1.616275c.3125631.31256146.4881584.7364869.4881584 1.17851667v6.71705c0 .9204746-.7461921 1.6666667-1.6666667 1.6666667h-6.66666667c-.92047458 0-1.66666666-.7461921-1.66666666-1.6666667z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiles);
export default __webpack_public_path__ + "static/media/files.bff7831f12a2595f0d614c9dae2f602d.svg";
export { ForwardRef as ReactComponent };